import { localizations } from '@iheartjane/jane-iso-3166'
import { Localization } from '../../hooks/useLocalizations'

export interface SubdivisionOption {
  key: string
  value: string
  text: string
}

export const ALL_SUBDIVISION_OPTIONS: SubdivisionOption[] = [
  ...localizations.subdivisions.us
    .map((locale) => ({
      key: `US-${locale.code.toUpperCase()}`,
      value: `US-${locale.code.toUpperCase()}`,
      text: locale.displayName.en,
    }))
    .concat([
      ...localizations.subdivisions.ca.map((locale) => ({
        key: `CA-${locale.code.toUpperCase()}`,
        value: `CA-${locale.code.toUpperCase()}`,
        text: locale.displayName.en,
      })),
    ]),
]

export const localizationListToSubdivisionOptions = (apiLocalizations: Localization[] = []) => {
  let filteredLocalizationsUS = apiLocalizations.filter((l) => l.country === 'US')
  let filteredLocalizationsCA = apiLocalizations.filter((l) => l.country === 'CA')

  const sortedSubdivisionOptionsUS = filteredLocalizationsUS
    .map((localization: any) => {
      const subdivisionDisplayName =
        localizations.subdivisions.us.find((s) => s.code === localization.subdivision.toUpperCase())
          ?.displayName.en || 'Unknown'

      return {
        key: localization.subdivision || null,
        text: subdivisionDisplayName,
        value: localization.id || null,
      }
    })
    .sort((a, b) => {
      const fa = a.text.toLowerCase()
      const fb = b.text.toLowerCase()

      if (fa < fb) return -1
      if (fa > fb) return 1
      return 0
    })

  const sortedSubdivisionOptionsCA = filteredLocalizationsCA
    .map((localization: any) => {
      const subdivisionDisplayName =
        localizations.subdivisions.ca.find((s) => s.code === localization.subdivision.toUpperCase())
          ?.displayName.en || 'Unknown'

      return {
        key: localization.subdivision || null,
        text: subdivisionDisplayName,
        value: localization.id || null,
      }
    })
    .sort((a, b) => {
      const fa = a.text.toLowerCase()
      const fb = b.text.toLowerCase()

      if (fa < fb) return -1
      if (fa > fb) return 1
      return 0
    })

  return sortedSubdivisionOptionsUS.concat(sortedSubdivisionOptionsCA)
}

/**
 * Takes a list of subdivisions formatted for a dropdown and removes
 * any subdivisions that already have a localization. This is used
 * to prevent users from entering an existing subdivision when creating
 * a new localization
 */
export const removeLocalizationsFromSubdivisions = (
  subdivisionOptions: SubdivisionOption[] = [],
  localizations: Pick<Localization, 'country' | 'subdivision'>[] = []
) => {
  // create object with existing localizations as keys in format 'US-FL'
  const localizationSubdivisions = localizations.reduce(
    (acc: { [key: string]: true }, localization) => {
      const subdivisionKey = localization.country + '-' + localization.subdivision
      acc[subdivisionKey] = true
      return acc
    },
    {}
  )
  // filter out any subdivision options that exist in localizations
  return subdivisionOptions.filter(({ key }) => !localizationSubdivisions[key])
}
